import BaseService from "./BaseService.js";

class DataStoreService extends BaseService {
  getTifDashboard(query) {
    return this.apiGet({
      url: `/api/dashboard`,
      isStore: true,
      params: query,
    });
  }

  getForm(namespace = 'store') {
    return this.apiGet({
      url: `/form`,
      isDaf: true,
      params: { namespace },
    });
  }

  getSubjects(namespace, params) {
    return this.apiGet({
      url: `/api/subjects/${namespace}`,
      params,
      isStore: true
    });
  }

  getSubject(namespace, datastakeId) {
    return this.apiGet({
      url: `/api/subjects/${namespace}`,
      params: { pagination: { page: 1, perPage: 1 }, datastakeId },
      isStore: true
    });
  }

  saveSubjectSettings(id, data) {
    return this.apiPut({
      url: `/api/channel/${id}`,
      data,
      isStore: true
    });
  }

  getOptions(data) {
    return this.apiPost({
      url: '/query/data-options',
      isDaf: true,
      data,
    });
  }
}

export default new DataStoreService();
